const testimonials = [
  {
    business: "Marea People Partners",
    quote: {
      es: "Me encantó el producto final y más que cuando hay que actualizar la información es súper rápida y no tengo que esperar días.",
      en: "I loved the final product, and updating the information is super fast — I don't have to wait days for it.",
    },
  },
  {
    business: "Colaboratorio Carpintero",
    quote: {
      es: "Trabajar con ella fue muy sencillo, entiende perfecto la idea y honestamente quedó mejor de lo que esperaba.",
      en: "Working with her was very easy — she understood the idea perfectly, and honestly, it turned out better than I expected.",
    },
  },
  {
    business: "Fiat90",
    quote: {
      es: "Usarlo fue súper sencillo y más porque se puede descargar como app en el celular. Nos encantó la página y no puedo esperar por usar las nuevas versiones.",
      en: "It was super easy to use, especially since it can be installed as an app on your phone. We loved the site and I can't wait to use the new versions.",
    },
  },
];

export default testimonials;
